export const actionTypes = {
  SET_BRAND_CODE: 'selections/SET_BRAND_CODE',
  SET_SHIP_CODE: 'selections/SET_SHIP_CODE',
  SET_DATE: 'selections/SET_DATE',
  SET_CURRENCY: 'selections/SET_CURRENCY',
}

export const setBrandCode = payload => ({
  type: actionTypes.SET_BRAND_CODE,
  payload,
})

export const setShipCode = payload => ({
  type: actionTypes.SET_SHIP_CODE,
  payload,
})

export const setDate = payload => ({
  type: actionTypes.SET_DATE,
  payload: payload ? '' + payload : null,
})

export const setCurrency = payload => ({
  type: actionTypes.SET_CURRENCY,
  payload,
})
